export enum TimeOffStatusFilters {
  ALL = "All",
  PENDING = "Pending",
  APPROVED = "Approved",
  REJECTED = "Rejected",
  ADD_DOCUMENTATION = "Add documentation",
  CANCELLED = "Cancelled",
  PENDING_CANCELLATION = "Pending Cancellation",
}
